import Utils from '../../modules/utils'

// Posts to the Claude assistant endpoint (POST /api/claude).
// `history` is the prior conversation ([{role, text}, ...]) so follow-ups work.
const saveClaudeMessage = (message, history, callbackFunc) => {
  Utils.post('claude', {message, history}, callbackFunc)
}

// Status of a queued report or presentation (GET /api/claude/:id).
const getClaudeJobStatus = (id, callbackFunc) => {
  Utils.get(`claude/${id}`, callbackFunc)
}

export {saveClaudeMessage, getClaudeJobStatus}
